import { apiErrors, apiMethodnames } from '../constants/common';
import { DISCOVER, MA, VISA } from '../constants/partnering-networks';
import handleSrcProfiles from '../handlers/handle-src-profiles';
import collapsedLogger from '../helpers/collapsed-logger';
import getNetworkInstance from '../helpers/get-network-instance';
import { trackVisaUnrecognizedReturningUser } from '../helpers/gtm';
import isEmptyString from '../helpers/is-empty-string';
import OrchCustomData from '../helpers/orch-custom-data';
import promiseTimeout from '../helpers/promise-timeout';

const timeOutError = network => ({
  [network]: {
    error: apiErrors.TIME_OUT
  }
});
const promiseRejectError = network => ({
  [network]: {
    error: apiErrors.REJECT
  }
});

const promiseWrapper = function(instance, instanceName, data, method) {
  return new Promise(resolve => {
    if (instance === null || instance === undefined) {
      const resultData = {
        [instanceName]: {
          error: apiErrors.NO_INSTANCE
        }
      };
      resolve(resultData);
    }
    collapsedLogger(`-- ${instanceName} getSrcProfile API with network name and input data`, data);
    const vco = getNetworkInstance(OrchCustomData, VISA);
    instance[method](data)
      .then(res => {
        const resultData = {
          [instanceName]: res
        };
        OrchCustomData.apiTimeStamp.getSrcProfile[instanceName].endTime = Date.now();
        OrchCustomData.apiTimeStamp.getSrcProfile[instanceName].timeTakenInMillSeconds =
          OrchCustomData.apiTimeStamp.getSrcProfile[instanceName].endTime -
          OrchCustomData.apiTimeStamp.getSrcProfile[instanceName].startTime;
        const step = `ORCH_GETSRCPROFILE_${instanceName}_API_SUCCESS_RESPONSE`;
        vco.pushEvents({
          E: step,
          ERRCODE: null,
          ERRMSG: null,
          ETIME: OrchCustomData.apiTimeStamp.getSrcProfile[instanceName].endTime,
          LL: 'INFO',
          S: 200,
          STIME: OrchCustomData.apiTimeStamp.getSrcProfile[instanceName].startTime,
          TY: 'RESPONSE',
          checkout_step: step,
          response: res,
          srcInitiatorId: OrchCustomData.srcInitiatorId[instanceName]
        });
        resolve(resultData);
      })
      .catch(error => {
        const resultData = {
          [instanceName]: error
        };
        const stepErr = `ORCH_GETSRCPROFILE_${instanceName}_API_ERROR_RESPONSE`;
        OrchCustomData.apiTimeStamp.getSrcProfile[instanceName].endTime = Date.now();
        OrchCustomData.apiTimeStamp.getSrcProfile[instanceName].timeTakenInMillSeconds =
          OrchCustomData.apiTimeStamp.getSrcProfile[instanceName].endTime -
          OrchCustomData.apiTimeStamp.getSrcProfile[instanceName].startTime;
        if (vco && typeof vco.pushEvents === 'function') {
          vco.pushEvents({
            E: stepErr,
            ERRCODE: error.error_code ? error.error_code : '',
            ERRMSG: error.msg ? error.msg : '',
            ETIME: OrchCustomData.apiTimeStamp.getSrcProfile[instanceName].endTime,
            LL: 'ERR',
            S: null,
            STIME: OrchCustomData.apiTimeStamp.getSrcProfile[instanceName].startTime,
            TY: 'RESPONSE',
            checkout_step: stepErr,
            response: error,
            srcInitiatorId: OrchCustomData.srcInitiatorId[instanceName]
          });
        }
        resolve(resultData);
      });
  });
};

const getSetSRCProfiles = data => {
  let idTokens = OrchCustomData.srcSdks.apiResponseCache.uniqueIdTokens;
  // in VSB integrations, merchant can pass idTokens array directly
  if (OrchCustomData.isVsb && Array.isArray(data?.idTokens)) {
    idTokens = data.idTokens;
  }
  if (idTokens.length === 0) {
    const isRecognizedRes = OrchCustomData.srcSdks.apiResponseCache.isRecognized;
    for (const key in isRecognizedRes) {
      if (isRecognizedRes[key].recognized) {
        idTokens = [...idTokens, ...isRecognizedRes[key].idTokens];
      }
    }
  }
  OrchCustomData.isGetSRCProfileInvoked = true;
  const { GET_SRC_PROFILE } = apiMethodnames;
  const promiseArr = [];
  const loadedSdk = OrchCustomData.srcSdks.loadedSdk;
  const visaRecognized = OrchCustomData.srcSdks?.apiResponseCache?.isRecognized?.VISA?.recognized;
  let visaInput;
  for (const key in loadedSdk) {
    OrchCustomData.apiTimeStamp.getSrcProfile[key] = {};
    OrchCustomData.apiTimeStamp.getSrcProfile[key].startTime = Date.now();
    const sdkInstance = loadedSdk[key];
    if (key === VISA) {
      const completeIdentityValidationRes =
        OrchCustomData.srcSdks.apiResponseCache.completeIdentityValidation;
      let otpProvider = OrchCustomData.srcSdks.orchConfig.preferredNetwork;
      //VCO-14958 -> fix step-up issue in VISA DCF for non-VISA recognized user
      if (isEmptyString(otpProvider)) {
        otpProvider = VISA;
      }
      // VCO-14507 need to pass otpProvider to system-sdk external
      visaInput =
        visaRecognized || completeIdentityValidationRes.VISA
          ? { idTokens: [], otpProvider }
          : { idTokens, otpProvider };
    }
    const sdkPromise = promiseTimeout(
      promiseWrapper(
        sdkInstance,
        key,
        key === MA || key === DISCOVER ? { idTokens } : key === 'VISA' ? visaInput : idTokens,
        GET_SRC_PROFILE
      ),
      timeOutError(key),
      promiseRejectError(key)
    );
    promiseArr.push(sdkPromise);
  }
  trackVisaUnrecognizedReturningUser(idTokens, OrchCustomData);

  return Promise.all(promiseArr).then(values => {
    for (const value of values) {
      OrchCustomData.setSrcProfile(value);
    }
    return handleSrcProfiles();
  });
};

export default getSetSRCProfiles;
